import React, { useState } from 'react';
import { AccordionItem, Box, Inscription, Preloader } from '@common-fe/common-fe';
import styled from 'styled-components';

import useIsEmbeddedOnly from '@/modules/deductibles/SpendTracker/hooks/useIsEmbeddedOnly';

import { TierBlock } from './TierBlock/TierBlock';
import { useTiersModule } from './hooks';

interface StyledBoxProps {
  isPageMode?: boolean;
}

export const StyledBox = styled(Box)<StyledBoxProps>`
  transition: all 0.15s;
  span {
    transition: all 0.15s;
  }
  a {
    height: 24px;
  }
`;

export const TiersModule: React.FC = () => {
  const [isExpanded, setExpanded] = useState(false);
  const { isLoadingAll, serviceConfigs, rule, triggerAmounts } = useTiersModule();
  const isEmbeddedOnly = useIsEmbeddedOnly(rule?.tiers?.map((tier) => tier.tierTriggers || []) || []);

  return (
    <StyledBox pad="l" round="moduleRound" background="module" isPageMode>
      {isLoadingAll && isExpanded ? (
        <Preloader testId="tiers-details" />
      ) : (
        <AccordionItem
          onChange={() => setExpanded(!isExpanded)}
          testId="tiers-module-item"
          iconSize="24px"
          isExpanded={isExpanded}
          text={
            <Inscription
              margin={{ left: 'xxs' }}
              color="textBody"
              weight="bold"
              size="16px"
              lineHeight="22px"
            >
              Tiers
            </Inscription>
          }
          isLeftArrow
        >
          <Box margin={{ top: 'l' }}>
            {rule?.tiers?.map((item, index) => {
              return (
                <TierBlock
                  key={item?.id}
                  tier={item}
                  nextTier={rule?.tiers[index + 1]}
                  numberOfTier={String(index + 1)}
                  isLastItem={index === rule?.tiers?.length - 1}
                  serviceConfigs={serviceConfigs}
                  triggerAmounts={triggerAmounts}
                  isEmbeddedOnly={isEmbeddedOnly}
                />
              );
            })}
          </Box>
        </AccordionItem>
      )}
    </StyledBox>
  );
};
